import React, { useEffect, useState } from "react";
import "./dev_profile.css";
import devAva from "../../assets/dev_ava.png";
import { Btn, FormInput, SuccessComp } from "../../utils/utils";
import { AxiosAuthGet, AxiosAuthPut } from "../../api/api";
import Loading from "../ui/Loading";
import PicUpload from "../../utils/PicUpload";

const DevProfile = () => {
  const getUrl = "developer/profile/";

  const [profLoading, setProfLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [profData, setProfData] = useState();
  const [sucMsg, setSucMsg] = useState("");
  const [isEditDone, setIsEditDone] = useState(false);
  const [images, setImages] = useState();
  const [data, setData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    city: "",
    state: "",
    developerName: "",
    pictures: "",
  });
  const [dataErr, setDataErr] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    city: "",
    state: "",
    developerName: "",
    pictures: "",
  });

  const dataChange = (e) => {
    const newData = { ...data };
    newData[e.target.id] = e.target.value;
    setData(newData);
    const newDataErr = { ...dataErr };
    newDataErr[e.target.id] = "";
    setDataErr(newDataErr);
    // console.log(newData);
  };

  const getProf = () => {
    setProfLoading(true);
    AxiosAuthGet(getUrl)
      .then((res) => {
        // console.log(res);
        setProfData(res.data);
        setProfLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setProfLoading(false);
      });
  };

  useEffect(() => {
    getProf();
    // eslint-disable-next-line
  }, [isEditDone]);

  const dataObj = {
    name: data.name ? data.name : profData?.name,
    email: data.email ? data.email : profData?.email,
    phoneNumber: data.phoneNumber ? data.phoneNumber : profData?.phoneNumber,
    city: data.city ? data.city : profData?.city,
    state: data.state ? data.state : profData?.state,
    picture: data.pictures ? data.pictures[0] : profData?.pictures,
    developerName: data.developerName ? data.developerName : profData?.developerName,
  };

  const editProf = () => {
    setIsLoading(true);
    AxiosAuthPut(getUrl, dataObj)
      .then((res) => {
        // console.log(res);
        setSucMsg(res?.message);
        setData({
          name: "",
          phoneNumber: "",
          email: "",
          city: "",
          pictures: "",
          state: "",
        });
        setTimeout(() => {
          setIsEditDone(true);
          window.location.reload();
          setSucMsg("");
        }, 2000);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsLoading(false);
      });
  };

  return profLoading ? (
    <Loading />
  ) : (
    <div>
      <SuccessComp message={sucMsg} />
      <div className="dev_prof_head">
        <img
          src={
            profData?.picture !== null
              ? profData?.picture
              : data?.pictures
                ? data?.pictures
                : devAva
          }
          alt="dev_ava"
        />
        <PicUpload
          images={images}
          setData={setData}
          data={data}
          setImages={setImages}
          dataErr={dataErr}
          btnText={"Upload New"}
        />
      </div>
      <div className="dev_prof_body">
        <div className="d_p_b_inp">
          <div className="eac_inp">
            <FormInput
              label={"Full Name"}
              id={"name"}
              changeInput={dataChange}
              placeholder={profData?.name}
              value={data.name}
              err={dataErr.name}
            />
          </div>
          <div className="eac_inp">
            <FormInput
              label={"Email Address"}
              id={"email"}
              changeInput={dataChange}
              placeholder={profData?.email}
              value={data.email}
              err={dataErr.email}
            />
          </div>
        </div>
        <div className="d_p_b_inp">
          <div className="eac_inp">
            <FormInput
              label={"Phone Number"}
              id={"phoneNumber"}
              changeInput={dataChange}
              type={"Number"}
              placeholder={profData?.phoneNumber}
              value={data.phoneNumber}
              err={dataErr.phoneNumber}
            />
          </div>
          <div className="eac_inp">
            <FormInput
              label={"City"}
              id={"city"}
              changeInput={dataChange}
              placeholder={profData?.city}
              value={data.city}
              err={dataErr.city}
            />
          </div>
        </div>
        <div className="d_p_b_inp">
          <div className="eac_inp">
        <FormInput
          label={"State"}
          id={"state"}
          changeInput={dataChange}
          placeholder={profData?.state}
          value={data.state}
          err={dataErr.state}
        />
          </div>
          <div className="eac_inp">
            <FormInput
              label={"Developer Name"}
              id={"developerName"}
              changeInput={dataChange}
              placeholder={profData?.developerName}
              value={data.developerName}
              err={dataErr.developerName}
            />
          </div>
        </div>
        <Btn
          btnClick={editProf}
          btnText={"Save Changes"}
          btnClass={"home-btn_s"}
          loading={isLoading}
        />
      </div>
    </div>
  );
};

export default DevProfile;
